import React from 'react';

export default function BioTrackerLogo() {
  return (
    <div className="biotracker-logo">
      <img src="/images/Biotracker.logo.svg" alt="BioFilm" width={"45%"} />
    </div>
  )
}